/** Ссылка для шаринга в браузере — представление без стора, всё приходит пропсами. */
import { Button, WindowShell } from "../kit";
import { useT } from "../../../app";
import "./styles.css";

export interface ShareLinkViewProps {
  url: string;
  /** Ссылка уже в буфере; иначе поле с выделенной ссылкой и кнопка «Скопировать». */
  copied: boolean;
  onCopy(): void;
  onDone(): void;
}

export function ShareLinkView({ url, copied, onCopy, onDone }: ShareLinkViewProps) {
  const t = useT();
  return (
    <WindowShell kind="shareLink" title={t(copied ? "win.shareLink.copied" : "win.shareLink.title")}>
      <p class="win-text" data-testid="share-link-text">
        {t(copied ? "win.shareLink.copiedText" : "win.shareLink.text")}
      </p>
      <input
        class="win-share-link__field"
        readOnly
        value={url}
        aria-label={t("win.shareLink.title")}
        data-testid="share-link-url"
        onFocus={(e) => e.currentTarget.select()}
        ref={(el) => {
          if (el && !copied) el.select();
        }}
      />
      <div class="win-actions">
        {!copied && (
          <Button onClick={onCopy} data-testid="share-link-copy">
            {t("win.shareLink.copy")}
          </Button>
        )}
        <Button {...(copied ? {} : { tone: "link" as const })} onClick={onDone} data-testid="share-link-done">
          {t("win.shareLink.done")}
        </Button>
      </div>
    </WindowShell>
  );
}
